<script>
    import {Splide, SplideSlide} from "@splidejs/svelte-splide";
    import {eventBus} from "../core/event-bus-store.js";
    import {mediaUrlStore} from "../core/app-store.js";

    export let gallery = {};
    export let tenantKey = '';

    const options = {
        type: 'loop',
        height: '50vh',
        drag: true,
        lazyLoad: 'nearby',
        preloadPages: 1,
        snap: true,
        interval: 5000,
        autoplay: false,
        // perPage: 2,      // desktop
        // gap: '1.5rem',   // desktop
        mediaQuery: 'max',
        breakpoints: {
            640: {          // mobile
                arrows: false,
                perPage: 1,
                gap: 0,
            }
        },
    };

    options.height = `${gallery?.height || 50}vh`;
    options.autoplay = gallery?.autoplay === true;
    options.interval = gallery?.autoplayInterval || 5000;

    let id = Math.random().toString().split('.')[1];

    const openFullscreen = (media) => {
        eventBus.set([{event: 'openFullscreen', payload: {media}}]);
    }

</script>
<style>
.gallery-container {
    height: 100%;
    width: 100%;
    max-height: 100%;
    min-width: 100%;
    position: relative;
}
.gallery-item {
    height: 100%;
    position: relative;
}
.text-container {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 1rem 1rem 1rem 1rem;
    text-align: left;
    font-family: PT Mono, sans-serif;
}
.title.label {
    opacity: 1;
}
.text {
    font-size: .9rem;
    font-weight: 200;
    line-height: 1.35;
}

.image,
.video,
.video video {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.gallery-button {
    padding: 0;
    margin: 0;
    border: none;
    background: none;
    cursor: pointer;
    width: 100%;
    height: 100%;
}

</style>

<div class="gallery-container">
    <Splide id={id} aria-label="" options={options}>
        {#each gallery.items as media}
            <SplideSlide>
                <div class="gallery-item">

                    {#if (media.type === 'photo')}
                        <button class="gallery-button"
                                on:click={() => openFullscreen(media)}
                                on:keydown={(e) => e.key === 'Enter' && openFullscreen(media)}>
                            <img class="image"
                                 src="{$mediaUrlStore}{media.ref || tenantKey}{media.url}"
                                 loading="lazy"
                                 alt="{media?.title}">
                        </button>
                    {/if}

                    {#if (media.type === 'video')}
                        <div class="video">
                            <video controls="true" loading="lazy">
                                <source src="{$mediaUrlStore}{media.ref || tenantKey}{media.url}" type="video/mp4">
                                <track kind="captions">
                            </video>
                        </div>
                    {/if}

                    {#if (media.title || media.text) }
                        <div class="text-container flex-column gap-05">
                            {#if (media.title)}
                                <div class="title label">{ media.title }</div>
                            {/if}
                            {#if (media.text)}
                                <div class="text">{ media.text }</div>
                            {/if}
                        </div>
                    {/if}
                </div>

            </SplideSlide>
        {/each}
    </Splide>
</div>
